const usePermissionConfig = () => {
  return {
    // 创建应用
    CREATE: 'OPS-AGL-YYGL-CJYY',
    // 编辑
    UPDATE: 'OPS-AGL-YYGL-BJ',
    // 启用停用
    ENABLE: 'OPS-AGL-YYGL-QYTY',
    // 操作记录
    LOG: 'OPS-AGL-YYGL-CZJL',
    // 删除
    DELETE: 'OPS-AGL-YYGL-SC',
  } as const;
};

export default usePermissionConfig;
